module.exports = __webpack_public_path__ + "img/112.6ca73094.png";